import React from "react";
import ReactDOM from "react-dom/client";
// import Header from "./components/Header";
import Header2 from "./components/Header2";
import Footer from "./components/Footer";
import Error from './components/Error';
import LoveListChecker from "./components/LoveListChecker";
import LandingPage from './pages/LandingPage';
import ScrollToTop from "./Helpers/ScrollToTop";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

import '../src/styles/main.scss';
import MemeCreator from "./pages/MemeCreator";

import AurasPage from './pages/Auras';
import ArtistsProject from './pages/ArtistsProjectCollabs';
import TeamPage from './pages/Team';
import PetsPage from './pages/Pets';
import IPrightsPage from './pages/IPRights';
import TwitterPage from './pages/TwitterPage';
import MarketplacePage from './pages/MarketplacePage';
import ProfilePicture from "./pages/ProfilePicture";
import CreateBanner from "./pages/CreateBanner";

function AppLayout() {
  return (
    <>
      <Header2 />
      <ScrollToTop />
      {
        <Outlet />
      }
      <Footer />
    </>
  );
}
// just the creation of routing configuration (createBrowserRouter function is used to create routes)
const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/lovelist",
        element: <LoveListChecker />,
      },
      {
        path: "/meme-creator",
        element: <MemeCreator />,
      },
      {
        path: "/auras",
        element: <AurasPage />,
      },
      {
        path: "/artistsproject",
        element: <ArtistsProject />,
      },
      {
        path: "/team",
        element: <TeamPage />,
      },
      {
        path: "/pets",
        element: <PetsPage />,
      },
      {
        path: "/IPrights",
        element: <IPrightsPage />,
      },
      {
        path: "/twitter",
        element: <TwitterPage />,
      },
      {
        path: "/marketplace",
        element: <MarketplacePage />,
      },
      {
        path: "/profile",
        element: <ProfilePicture />,
      },
      {
        path: "/banner",
        element: <CreateBanner/>,
      },
    ],
  },
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={appRouter} />)